var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileinputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.617,
    height: 16.602,
    viewBox: "0 0 16.617 16.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(-1610.25 -534.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M15,11.314a3.777,3.777,0,0,0,5.7.408l2.266-2.266a3.777,3.777,0,1,0-5.342-5.342l-1.3,1.292",
    transform: "translate(1602.048 531.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M12.062,15.007a3.777,3.777,0,0,0-5.7-.408L4.1,16.866a3.777,3.777,0,1,0,5.342,5.342l1.291-1.292",
    transform: "translate(1608.007 526.788)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileinputIcon);
export default __webpack_public_path__ + "static/media/fileinput-icon.f7b827f634b51ae55d6e1a50870de724.svg";
export { ForwardRef as ReactComponent };